import React from 'react';
import { isNil } from 'lodash';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import Anchor from '../../../../../components/link/Anchor';
import { openNewWindow } from '../../../../../lib/common';
import { BRAND_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { Columns } from '../../../../../types/common/table';
import moment from '../../../../../lib/moment';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import TableColumnModalImg from '../../../../../components/table/TableColumModalImg';
import { BrandItemV2 } from '../../../../../types/brand/list';
import { WidgetBrandFilterOption } from '../../../../../types/widget';
import { makeDetailPageUrl } from '../../../../../lib/utils/urlUtils';
import { makeNumberWithComma } from '../../../../../lib/utils/numberUtils';

export const brandReactTableColumns: Columns<BrandItemV2, WidgetBrandFilterOption> = (data) => {
  const { filterOption = {}, onFilter } = data;

  return [
    {
      accessor: 'imageUrl',
      Header: '이미지',
      width: 100,
      Cell: (row) => <TableColumnModalImg url={row.value} />,
    },
    {
      accessor: 'name',
      Header: '브랜드명',
      filterable: true,
      width: 200,
      Filter: () => <TableFilterInput option={filterOption.name} onFilter={(name: string) => onFilter({ name })} />,
    },
    {
      accessor: 'id',
      Header: '브랜드 ID',
      filterable: true,
      width: 100,
      Cell: (row) => (
        <Anchor
          color="primary"
          isUnderLine
          text={row.value}
          onClick={() => openNewWindow(makeDetailPageUrl(BRAND_DETAIL_URL_PATH, row.value))}
        />
      ),
      Filter: () => (
        <TableFilterInput
          type="number"
          option={filterOption.id}
          onFilter={(id: string): void => onFilter({ id: isNil(id) ? id : Number(id) })}
        />
      ),
    },
    {
      accessor: 'tier',
      Header: '브랜드 티어',
      width: 70,
    },
    {
      accessor: 'likeCount',
      Header: '브랜드 찜 수',
      Cell: ({ value }) => makeNumberWithComma(value),
    },
    {
      accessor: 'activeProductCount',
      Header: '판매중인 상품 수',
      Cell: ({ value }) => makeNumberWithComma(value),
    },
    {
      accessor: 'createDate',
      Header: '입점일자',
      Cell: ({ value }) => moment(value).format(DATE_FORMAT.FULL_DASH_FORMAT),
    },
  ];
};
